import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import Header from './components/Header';
import { NotificationContainer } from './components/Notifications';
import { Toaster } from './components/ui/sonner';
import Dashboard from './pages/Dashboard';
import FormBuilder from './pages/FormBuilder';
import CreateLink from './pages/CreateLink';
import PublicForm from './pages/PublicForm';
import FormSubmissions from './pages/FormSubmissions';
import SharedKnowledge from './pages/SharedKnowledge';
import Settings from './pages/Settings';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import AnonymousAccess from './pages/AnonymousAccess';
import AnonymousFormFillForm from './pages/AnonymousFormFillForm';

const BASENAME = process.env.PUBLIC_URL || '/';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <NotificationProvider>
          <AuthProvider>
            <LanguageProvider>
              <Router basename={BASENAME}>
              <div className="min-h-screen bg-background">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/public/:identifier" element={<PublicForm />} />
                <Route path="/anonymous/:accessToken" element={<AnonymousAccess />} />
                <Route path="/anonymous/:accessToken/forms/:formId" element={<AnonymousFormFillForm />} />

                <Route path="/*" element={
                  <ProtectedRoute>
                    <Header />
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/knowledge" element={<SharedKnowledge />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/forms/new" element={<FormBuilder />} />
                      <Route path="/forms/:id/edit" element={<FormBuilder />} />
                      <Route path="/forms/:formId/create-link" element={<CreateLink />} />
                      <Route path="/forms/:id/submissions" element={<FormSubmissions />} />
                    </Routes>
                  </ProtectedRoute>
                } />
              </Routes>
              <NotificationContainer />
              <Toaster />
              </div>
              </Router>
            </LanguageProvider>
          </AuthProvider>
        </NotificationProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
